/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class ActiveProcessTypesModel{

        public activeProcessTypes: Wars.Domain.Model.ProcessType[];

        constructor(private processTypeService: services.ProcessTypeService) {
            this.processTypeService.getActiveProcessTypes().then(result => {
                this.activeProcessTypes = result;
            });
        } 
    }
}